import { pt } from '../locales/pt_BR';

export const ptLang = {
  messages: {
    ...pt,
  },
  locale: 'pt-BR',
};



// WEBPACK FOOTER //
// ./src/lang/entries/pt-BR.js